import { createContext, useState , useEffect } from "react";
import axios from "axios";
import {
  useLocation
} from "react-router-dom";
import { lang } from "moment";
import NoMatch from "../components/NoMatch";

const DataFetchContext = createContext();
export const DataFetch = ({children}) => {
  const location = useLocation()
    const [data, setData] = useState([]);
    const [data1, setdata1] = useState([]);
    const [data2, setdata2] = useState([]);
    const [MacthDataBetween, setMacthDataBetween] = useState([]);
    const [MacthCount, setMacthCount] = useState(-1);
    const [loading, setLoading] = useState(true);
    const [HomeLastMatchData , setHomeLastMatchData] =useState([])
    const [AwayLastMatchData , setAwayLastMatchData] =useState([])
    const [HomeNextMatchData , setHomeNextMatchData] =useState([])
    const [AwayNextMatchData , setAwayNextMatchData] =useState([])
    const [PointTable , setPointTable] = useState([])
    const [StaticsHome , setStaticsHome] = useState([])
    const [StaticsAway , setStaticsAway] = useState([])
    const [TeamPastStatic , setTeamPastStatic] = useState([])
    const [ApiUrl , setApiUrl] = useState("https://srstapi.nvpark.com") 
    const [DataEmpty , setDataEmpty] = useState(false)
    const [Channel , setChannel] = useState([])
    const [funfacts , setfunfacts] = useState([])





    const TeamsInfoDataFunc2 =  () => {
      var date = new Date();
      var offsetInMinute = (date.getTimezoneOffset() / 60 ) *60;

        axios({
          method: 'get',
            url: `${ApiUrl}/api/H2H?matchId=${location.pathname.split("/")[2]}&lang=en&timezone=${offsetInMinute > 0 ? -Math.abs(offsetInMinute) : Math.abs(offsetInMinute) }`
        })
          .then(res => {
             if(res.status == 200 && res.data.isScreenValidate !==false && (res.data.params.result.homeTeamId !==0 && res.data.params.result.awayTeamId !==0)){
              setData(res.data.params.result)
              setdata1(res.data.params.result.jerseys[0])
              setdata2(res.data.params.result.jerseys[1])
              setChannel(res.data.params.result.channels)
              axios({
                method: 'get',
                url:  `${ApiUrl}/api/LastMeetings?homeTeam_Id=${res.data.params.result.homeTeamId}&awayTeam_Id=${res.data.params.result.awayTeamId}&timezone=${offsetInMinute > 0 ? -Math.abs(offsetInMinute) : Math.abs(offsetInMinute)}&lang=en&rowCount=5`}).then(res2 => {
                  if(res2.data.isScreenValidate !==false){
                    setMacthCount(res2.data.params.result.length)
                    setMacthDataBetween(res2.data.params.result)
                  }
                })
                axios({
                  method: 'get',
                  url:  `${ApiUrl}/api/OtherMeetings?homeTeam_Id=${res.data.params.result.homeTeamId}&awayTeam_Id=${res.data.params.result.awayTeamId}&matchId=${res.data.params.result.eventid}&timezone=${offsetInMinute > 0 ? -Math.abs(offsetInMinute) : Math.abs(offsetInMinute)}&lang=en&rowCount=5`}).then(res3 => {
                    if(res3.data.isScreenValidate !==false) {
                      setHomeLastMatchData(res3.data.params.result.homeTeamLastMeetings)
                      setAwayLastMatchData(res3.data.params.result.awayTeamLastMeetings)
                      setHomeNextMatchData(res3.data.params.result.homeTeamNextMeetings)
                      setAwayNextMatchData(res3.data.params.result.awayTeamNextMeetings)
                      setLoading(false)
                    }
                 
                    setLoading(false)
                  })
             }
          
             
            else if(res.status === "pending"){
              setLoading(true)
            }
            else{
              setLoading(false)
              setDataEmpty(true)
            }

          })

      
       
      };

      const FunAccrort = async () => {
        var date = new Date();
        var offsetInMinute = (date.getTimezoneOffset() / 60 ) *60;
        try {
          const {data} = await axios.get(`${ApiUrl}/api/H2H?matchId=${location.pathname.split("/")[2]}&lang=${sessionStorage.getItem("lang")}&timezone=${offsetInMinute > 0 ? -Math.abs(offsetInMinute) : Math.abs(offsetInMinute) }`);
          setfunfacts(data.params.result.funfacts)

        } catch (error) {
        }
        };

          const PointTableDataFunc = async () => {
            let sportId = location.pathname.split("/")[3]
            let categoryId = location.pathname.split("/")[4]
            let tourId = location.pathname.split("/")[5]
            try {
              const {data} = await axios.get(`${ApiUrl}/api/LeaguePointTable/${sportId}/${categoryId}/${tourId}/${sessionStorage.getItem("lang")}`);
              setPointTable(data.params.result)
             
  
            } catch (error) {
              
            }
            };

      useEffect(() => {
        if(location.pathname.split("/")[1] !== "pt"){
          TeamsInfoDataFunc2();
          PointTableDataFunc();
        }
        else{
          setLoading(false)
        }

      },[])

      // useEffect(() => {
      //   FunAccrort();
      // })

      const values = {
        data,
        data1,
        data2,
        MacthDataBetween,
        MacthCount,
        loading,
        HomeLastMatchData,
        AwayLastMatchData,
        HomeNextMatchData,
        AwayNextMatchData,
        PointTable,
        StaticsHome,
        StaticsAway,
        TeamPastStatic,
        DataEmpty,
        setLoading,
        Channel,
        ApiUrl,
        funfacts,
        ApiUrl
      }
  return (
    <DataFetchContext.Provider value={values}>{children}</DataFetchContext.Provider>
  )
}


export default  DataFetchContext;